import styled, { css } from "styled-components";
import { Icon, IconNames } from "../../../../../components/Icon";
import { Body, Callout } from "../../../../../components/Typography";
import { ItemType, VariantItem } from "../../../../../dropTypes";
import {
  smallScreenAndAbove,
  xSmallScreen,
} from "../../../../../lib/mediaQuery";

interface ExtraContentProps {
  contentItem: VariantItem;
  index: number;
}

export const ExtraContent = ({ contentItem, index }: ExtraContentProps) => {
  return (
    <Container key={`element_${index}`}>
      <ContentIcon
        type={contentItem.type}
        css={`
          margin-right: 10px;
          &[data-is-star="true"] {
            margin-left: -3px;
            margin-right: 6px;
          }
        `}
      />
      <Body
        css={`
          ${xSmallScreen(
            css`
              display: none;
            `
          )}
        `}
      >
        {contentItem?.name}
      </Body>
      <Callout
        css={`
          ${smallScreenAndAbove(
            css`
              display: none;
            `
          )}
        `}
      >
        {contentItem?.name}
      </Callout>
    </Container>
  );
};

interface ContentIconProps {
  type: ItemType;
  className?: string;
}
export const ContentIcon = ({ type, className }: ContentIconProps) => {
  let iconName: IconNames;
  const contentType = type.split("-").pop();
  switch (contentType) {
    case "audio":
      iconName = "Headphones";
      break;
    case "video":
      iconName = "Video";
      break;
    case "image":
      iconName = "Images";
      break;
    default:
      iconName = "Star";
  }
  return (
    <StyledIcon
      name={iconName}
      data-is-star={iconName === "Star"}
      className={className}
      color={`rgba(var(--white-light))`}
    />
  );
};

export const StyledIcon = styled(Icon)`
  height: 14px;
  width: 14px;
  &[data-is-star="true"] {
    height: 16px;
    width: 16px;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-xs) var(--spacing-sm);
  border-radius: var(--border-radius-sm);
  background: var(--dark-container-bg);
  &:not(:first-child) {
    margin-top: var(--spacing-xxs);
  }
`;
